var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.969,
    height: 32.931,
    viewBox: "0 0 43.969 32.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list_1_",
    "data-name": "list (1)",
    transform: "translate(0 -64.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15262",
    "data-name": "Path 15262",
    d: "M157.417,64.267H132.579a4.048,4.048,0,0,0,0,8.1h24.838a4.048,4.048,0,0,0,0-8.1Z",
    transform: "translate(-117.495 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15263",
    "data-name": "Path 15263",
    d: "M4.048,64.267A4.048,4.048,0,1,0,8.1,68.315,4.052,4.052,0,0,0,4.048,64.267Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15264",
    "data-name": "Path 15264",
    d: "M4.048,208.867A4.048,4.048,0,1,0,8.1,212.915,4.052,4.052,0,0,0,4.048,208.867Z",
    transform: "translate(0 -132.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15265",
    "data-name": "Path 15265",
    d: "M4.048,353.467A4.048,4.048,0,1,0,8.1,357.515,4.052,4.052,0,0,0,4.048,353.467Z",
    transform: "translate(0 -264.365)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6959",
    "data-name": "Group 6959",
    transform: "translate(4.048 64.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15266",
    "data-name": "Path 15266",
    d: "M51.182,68.315a4.052,4.052,0,0,0-4.048-4.048v8.1A4.052,4.052,0,0,0,51.182,68.315Z",
    transform: "translate(-47.134 -64.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15267",
    "data-name": "Path 15267",
    d: "M51.182,212.915a4.052,4.052,0,0,0-4.048-4.048v8.1A4.052,4.052,0,0,0,51.182,212.915Z",
    transform: "translate(-47.134 -196.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15268",
    "data-name": "Path 15268",
    d: "M51.182,357.515a4.052,4.052,0,0,0-4.048-4.048v8.1A4.052,4.052,0,0,0,51.182,357.515Z",
    transform: "translate(-47.134 -328.632)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15269",
    "data-name": "Path 15269",
    d: "M332.686,64.267H320.267v8.1h12.419a4.048,4.048,0,0,0,0-8.1Z",
    transform: "translate(-292.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15270",
    "data-name": "Path 15270",
    d: "M157.417,208.867H132.579a4.048,4.048,0,0,0,0,8.1h24.838a4.048,4.048,0,0,0,0-8.1Z",
    transform: "translate(-117.495 -132.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15271",
    "data-name": "Path 15271",
    d: "M332.686,208.867H320.267v8.1h12.419a4.048,4.048,0,0,0,0-8.1Z",
    transform: "translate(-292.764 -132.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15272",
    "data-name": "Path 15272",
    d: "M157.417,353.467H132.579a4.048,4.048,0,0,0,0,8.1h24.838a4.048,4.048,0,0,0,0-8.1Z",
    transform: "translate(-117.495 -264.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15273",
    "data-name": "Path 15273",
    d: "M332.686,353.467H320.267v8.1h12.419a4.048,4.048,0,0,0,0-8.1Z",
    transform: "translate(-292.764 -264.365)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.76caea29.svg";
export { ForwardRef as ReactComponent };